import React from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {
  Col, CardBody, Row
} from 'reactstrap';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { withRouter } from 'react-router-dom';
import { SaveHelpText, GetControl } from '../../queries/controls';
import { Mutation, withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { signout } from '../../redux/actions/userActions';
import data from './HelpText.js'
// import toolbarOptions from './toolbar'
import $ from 'jquery';


class HelpTextEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      contentState: {},
      control: {}
    };
  }

  async componentDidMount () {
    let { data: controlData } = await this.props.client.query({
      query: GetControl(!this.props.match.params.highlevel_category,
        this.props.match.params.frameworkName.toLowerCase(),
        this.props.match.params.highlevel_category ?
          this.props.match.params.highlevel_category.toLowerCase()
          : '',
        require('base-64').decode(this.props.match.params.lowlevel_category).toLowerCase()
          .replace(/\n/g, "\\n"),
        //this.props.location.state.lowLevelCategory.toLowerCase(),
        this.props.match.params.control_id
      ),
      fetchPolicy: 'network-only',
      skip: this.state.summaryLoading
    })
    this.setState({
      control: controlData.control
    })
    let html = data.data;
    html = html.replace('{framework}', this.props.match.params.frameworkName
      .toLowerCase().toUpperCase())
    html = html.replace('{category}', this.state.control.referenceID)
    // console.log(this.props.location.state
    //   .control.helpText)
    const contentBlock = htmlToDraft(this.state.control.helpText ?
      this.state.control.helpText.replace(/\\+n/g, '') : html.replace(/\\+n/g, ''));
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      this.setState({
        editorState: editorState
      })
    }

  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
    //console.log(`Editor State: ${JSON.stringify(this.state.editorState)}`)
  };

  onContentStateChange = (contentState) => {
    this.setState({
      contentState,
    });
    //console.log(`Content State: ${JSON.stringify(this.state.contentState)}`)
  };

  onSaveDone = (selector) => {
    $(selector).slideToggle(() => {
      setTimeout(() => {
        $(selector).slideToggle()
      }, 3000)
    })
  }

  render () {
    const { editorState, contentState } = this.state;
    // const fontFamilies = ['Verdana', 'Arial', 'Georgia', 'Impact', 'Lato', 'Roboto', 'Tahoma',
    //   'Times New Roman', 'Calibri', 'Comic Sans'];
    return (
      <div className="HelpTextEditor" >
        <div className="success-alert" id="success-alert">
          <p>
            {this.props.match.params.frameworkName.toLowerCase().toUpperCase()} &nbsp;
            Sub-Control: {this.state.control.referenceID} &nbsp;
            help text has been updated!
          </p>
        </div>
        <div className="fail-alert" id="fail-alert">
          <p>
            Encountered an issue while saving {this.props.match.params.frameworkName
              .toLowerCase().toUpperCase()} &nbsp;
            Sub-Control: {this.state.control.referenceID} &nbsp;
          </p>
        </div>
        <Row className="top-block">
          <div className="breadcrumbs" style={{ display: 'block' }}>
            {`${this.props.match.params.frameworkName.toLowerCase().toUpperCase()} > 
            ${this.props.match.params.highlevel_category ?
                `${this.props.match.params.highlevel_category.toUpperCase().substring(0, 15)}... >`
                : ''} 
            ${require('base-64').decode(this.props.match.params
                  .lowlevel_category).toUpperCase().substring(0, 27)}... > 
            ${this.state.control.referenceID}`}
          </div>
          <div className="control-heading" style={{ display: 'block' }}>
            <h3 className="page-title">{`Control: ${this.state.control.referenceID}`}</h3>
          </div>
        </Row>
        <Col className="editor-col">
          <div className="card">
            <CardBody>
              <Editor
                editorState={editorState}
                toolbarClassName="toolbarClassName toolbar"
                wrapperClassName="wrapperClassName editor"
                editorClassName="editorClassName"
                editorStyle={{
                  backgroundColor: 'white', border: '1px solid #ccc', height: '70vh',
                  marginBottom: '5px', padding: '0 15px'
                }}
                initialContentState={contentState}
                onEditorStateChange={this.onEditorStateChange}
                onContentStateChange={this.onContentStateChange}
                toolbar={{
                  options: ['inline','blockType', 'list', 'link', 'history'],
                  inline:{
                    options: ['superscript', 'subscript'],
                  },
                  list: {
                    options: ['unordered', 'ordered']
                  },
                  link: {
                    options: ['link']
                  }                
                }}
              />
            </CardBody>
          </div>
        </Col>
        <Col className="actions-col">
          <div className="card">
            <CardBody>
              <h5>Actions</h5>
              <hr style={{ color: '#aaa', backgroundColor: '#aaa' }} />
              <div className="history-section">
                <Mutation mutation={SaveHelpText()}
                  onCompleted={(data) => {
                    this.onSaveDone('#success-alert')
                  }}
                  onError={(data) => {
                    this.onSaveDone('#fail-alert')
                  }}
                >
                  {(addHelpTextToControl) => (
                    <button className='btn btn-primary account__btn'
                      onClick={() => {
                        let html = draftToHtml(convertToRaw(this.state.editorState
                          .getCurrentContent())).replace(/"/g, `'`);
                        addHelpTextToControl({
                          variables: {
                            helpTextData: {
                              framework: this.props.match.params.frameworkName.toLowerCase(),
                              controlID: this.state.control.controlID,
                              lowLevelCategory: require('base-64').decode(this.props.match.params
                                .lowlevel_category).replace(/\n/g, "\\n").toLowerCase(),
                              highLevelCategory: this.props.match.params.highlevel_category ?
                                this.props.match.params.highlevel_category.toLowerCase() : '',
                              helpText: html.replace(/\n/g, "\\\\n")
                            }
                          }
                        })
                      }}>Publish</button>
                  )}
                </Mutation>

                {/* <Link to='/app/dashboard' target='_blank'>Go to page.</Link> */}
              </div>
            </CardBody>
          </div>
          {/* <div>
              {draftToHtml(convertToRaw(editorState.getCurrentContent()))}
            </div> */}
        </Col>
      </div>

    )
  }

}

function mapStateToProps (state) {
  return {
    controls: state.controlsData.controls,
    frameworks: state.controlsData.frameworks,
    enabledFrameworks: state.controlsData.enabledFrameworks,
    summary: state.controlsData.summary,
    users: state.controlsData.users,
    user: state.auth.user,
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, { signout })(withRouter(withApollo(HelpTextEditor)));



// WEBPACK FOOTER //
// ./src/components/content_management/HelpTextEditor.js